module.exports = __webpack_public_path__ + "img/yjdhn_16.96dc4d65.png";